import { render } from "./NewOrderCartItems.vue?vue&type=template&id=9c1e77f2&scoped=true"
import script from "./NewOrderCartItems.vue?vue&type=script&lang=js"
export * from "./NewOrderCartItems.vue?vue&type=script&lang=js"

import "./NewOrderCartItems.vue?vue&type=style&index=0&id=9c1e77f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c1e77f2"]])

export default __exports__